import { createSlice } from "@reduxjs/toolkit";
 
 const navigateCheckoutSlice = createSlice({
   name: "navigateCheckout",
   initialState: {
     navigateCheckoutFlag: false,
   },
   reducers: {
     setnavigateCheckout(state, action) {
       state.navigateCheckoutFlag = action.payload;
     },
   },
 });
 
 export const { setnavigateCheckout } = navigateCheckoutSlice.actions;
 export default navigateCheckoutSlice.reducer;